"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludedPaths = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const browser_rum_1 = require("@datadog/browser-rum");
const react_1 = require("react");
const react_router_1 = require("react-router");
const cookieCutter_1 = __importDefault(require("../components/cookies/cookieCutter"));
const pageSpinner_1 = __importDefault(require("../components/molecules/pageSpinner"));
const errorPage_1 = __importDefault(require("../components/pages/errorPage"));
const landingPage_1 = __importDefault(require("../components/pages/landingPage"));
const loginform_1 = __importDefault(require("../components/pages/userAccount/loginform"));
const reactErrorBoundary_1 = __importDefault(require("./reactErrorBoundary"));
const Root_1 = __importDefault(require("./Root"));
const activity_1 = require("./routes/activity");
const approvals_1 = require("./routes/approvals");
const cookie_1 = require("./routes/cookie");
const dashboard_1 = require("./routes/dashboard");
const demo_1 = require("./routes/demo");
const error_1 = require("./routes/error");
const manageSettlements_1 = require("./routes/manageSettlements");
const request_1 = require("./routes/request");
const settings_1 = require("./routes/settings");
const signin_1 = require("./routes/signin");
const support_1 = require("./routes/support");
const supportSettings_1 = require("./routes/supportSettings");
const team_1 = require("./routes/team");
const teamsManageSettlements_1 = require("./routes/teamsManageSettlements");
const tos_1 = require("./routes/tos");
const wallet_1 = require("./routes/wallet");
require("./GoAppStyle.less");
exports.excludedPaths = ['signin', 'tos', 'request-demo', 'cookie-notice']; // on these routes we do not want to show the main sidemenu
globalThis.DD_RUM = browser_rum_1.datadogRum;
const GoApp = () => {
    const router = (0, react_router_1.createBrowserRouter)([
        {
            path: '/',
            element: ((0, jsx_runtime_1.jsx)(Root_1.default, { children: (0, jsx_runtime_1.jsxs)("div", { className: "content-right", children: [(0, jsx_runtime_1.jsx)(react_router_1.Outlet, {}), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? (0, jsx_runtime_1.jsx)(cookieCutter_1.default, {}) : null })] }) })),
            errorElement: ((0, jsx_runtime_1.jsx)(Root_1.default, { children: (0, jsx_runtime_1.jsx)(reactErrorBoundary_1.default, {}) })),
            hydrateFallbackElement: (0, jsx_runtime_1.jsx)(pageSpinner_1.default, {}),
            children: [
                { path: '/', element: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? (0, jsx_runtime_1.jsx)(loginform_1.default, {}) : (0, jsx_runtime_1.jsx)(landingPage_1.default, {}) },
                wallet_1.walletRoutes,
                dashboard_1.dashboardRoutes,
                error_1.errorRoutes,
                activity_1.activityRoutes,
                approvals_1.approvalRoutes,
                manageSettlements_1.settlementRoutes,
                teamsManageSettlements_1.teamsManageSettlements,
                request_1.requestRoutes,
                settings_1.settingsRoutes,
                team_1.teamRoutes,
                signin_1.signinRoutes,
                demo_1.demoRoutes,
                support_1.supportRoutes,
                supportSettings_1.supportAdminSettingsRoutes,
                tos_1.tosRoutes,
                cookie_1.cookieRoutes,
            ],
        },
        {
            path: '*',
            element: ((0, jsx_runtime_1.jsx)(Root_1.default, { children: (0, jsx_runtime_1.jsx)(errorPage_1.default, {}) })),
        },
    ], {
        future: {
        //There are no current future flags in React Router v7
        },
    });
    return ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageSpinner_1.default, { isLoading: true }), children: (0, jsx_runtime_1.jsx)(react_router_1.RouterProvider, { router: router }) }));
};
exports.default = GoApp;
